export type objectType = 'PAGE' | 'ARTICLE';

export const objectTypesAsArray: objectType[] = ['PAGE', 'ARTICLE'];
